import { createClient } from '@/shared/api';
import type { CreateStudyMutation, CreateStudyMutationVariables } from '@/shared/api';
import CREATE_STUDY_MUTATION from '../mutations/createStudy';

/**
 * Creates a study from the study form input. Runs CREATE_STUDY_MUTATION, throws createStudy.message when isSuccess is false, and returns the createStudy payload.
 *
 * @param input - Mutation input payload.
 * @returns The createStudy payload holding the new study.
 */
const handleCreateStudy = async (
  input: CreateStudyMutationVariables['input'],
): Promise<NonNullable<CreateStudyMutation['createStudy']>> => {
  const client = createClient();
  const createStudyResult = await client.mutate<CreateStudyMutation, CreateStudyMutationVariables>({
    mutation: CREATE_STUDY_MUTATION,
    variables: {
      input,
    },
  });
  const { data } = createStudyResult;
  // client.mutate's default errorPolicy throws before this line on any GraphQL error, so data is always present here.
  const { createStudy } = data!;
  if (!createStudy!.isSuccess) {
    throw new Error(createStudy!.message ?? undefined);
  }
  return createStudy!;
};

export default handleCreateStudy;
